<template>
  <data-container
    class="container-fluid"
    ref="container"
    :initial-filter="job ? { id: job } : undefined"
    :data-url="config.api.urls.jobs.list"
    :data-src="$store.state.jobs.stacks.current"
    :loader="loadJobs"
    :set-loaded-data="false"
  >
    <template slot-scope="container">
      <settings-container
        class="row job-list-filter mb-md"
        :initial="{ popover: null, orderByText: null }"
      >
        <template slot-scope="{ settings, set, setToggle }">
          <div class="col col-3">
            <search-field
              :placeholder="__('jobs.components.controls.common.search')"
              :icon-src="icon"
              @search="container.setSearch($event)"
            >
            </search-field>
          </div>

          <div class="col col-3 job-list-filter__user-switch">
            <toggle-switch
              :label="__('jobs.components.controls.common.today')"
              :value="
                !container.filter || !container.filter.hasDateToday ? 0 : 1
              "
              @on="container.setFilterKey('hasDateToday', 1)"
              @off="container.setFilterKey('hasDateToday', undefined)"
            >
            </toggle-switch>
          </div>

          <editable
            class="col col-6 pl-0"
            :show-toggle-button="false"
            :initial-data="{ orderby: container.orderBy }"
          >
            <editable-choose
              name="filter"
              class="job-list-filter__type-filter"
              @datachange="container.setFilterKey('status', $event.data)"
            >
              <template slot-scope="{ data, setData }">
                <button
                  type="button"
                  class="job-list-filter__btn-sort mr-mdsm"
                  @click="
                    setToggle('popover', {
                      which: 'filter',
                      target: $event.target,
                    })
                  "
                >
                  <img src="~smartdoors-shared/img/icons/filter.svg" />
                </button>
                <div class="jobs-list-control_navbar">
                  <button
                    :class="{
                      btn: true,
                      'btn-secondary': true,
                      selected:
                        !container.filter ||
                        (container.filter.status == undefined &&
                          !container.filter.id),
                    }"
                    @click="
                      setData(undefined);
                      unsetJob();
                    "
                  >
                    {{ __("jobs.components.controls.common.filter.all") }}
                  </button>
                  <button
                    v-for="(status, index) in statusFilter"
                    :key="index"
                    :class="{
                      btn: true,
                      'btn-secondary': true,
                      selected:
                        container.filter &&
                        container.filter.status &&
                        container.filter.status.toString() ==
                          status[0].toString(),
                    }"
                    @click="setData(status[0])"
                  >
                    {{ status[1] }}
                  </button>
                </div>
              </template>
            </editable-choose>

            <popover
              v-if="settings.popover && settings.popover.which == 'filter'"
              key="popover-filter-choose"
              :target="settings.popover.target"
              :hide-on-outside-click="false"
              type="info"
              position="bottom"
            >
              <div>
                <p class="mb-sm">
                  {{ __("jobs.components.controls.common.sort") }}
                </p>
                <editable-choose
                  name="orderby"
                  @datachange="
                    container.setOrderBy($event.data);
                    settings.popover = null;
                  "
                >
                  <ul
                    class="list-reset list-h pb-mdsm"
                    slot-scope="{ setData, data }"
                  >
                    <li
                      v-for="(text, orderBy) in {
                        id_extern: __(
                          'jobs.components.controls.common.sort_by.project_nr'
                        ),
                        date: __(
                          'jobs.components.controls.common.sort_by.date'
                        ),
                      }"
                      :key="orderBy"
                    >
                      <button
                        class="d-flex"
                        type="button"
                        @click="
                          setData(orderBy);
                          set('orderByText', text);
                        "
                      >
                        <img
                          class="mr-xs"
                          :src="
                            data == orderBy
                              ? require('smartdoors-shared/img/icons/checkbox-checked.svg')
                              : require('smartdoors-shared/img/icons/checkbox-unchecked.svg')
                          "
                        />
                        {{ text }}
                      </button>
                    </li>
                  </ul>
                </editable-choose>
              </div>
            </popover>

            <popover
              v-if="settings.orderByText"
              key="popover-filter-current"
              target=".job-list-filter__btn-sort"
              relative-to="$parent"
              position="left"
              :hide-on-outside-click="false"
              @close="
                container.setOrderBy(undefined);
                set('orderByText', null);
              "
            >
              {{ settings.orderByText }}
            </popover>
          </editable>
        </template>
      </settings-container>

      <div
        :class="{
          row: true,
          'job-list-container': true,
          'is-loading': container.isLoading,
        }"
      >
        <job-list
          class="container-fluid"
          :data="container.data"
          :is-loading="container.isLoading"
          :is-filtered="container.isFiltered"
          @clear-filter="
            container.clearFilter();
            unsetJob();
          "
        >
          <template slot="joblink" slot-scope="{ job, insidejob }">
            <!-- <a v-if="!insidejob" :class="!insidejob ? 'text-decoration-underline' : 'no-link'" @click=" -->
            <span v-if="insidejob">
              {{ job.id_extern }}
            </span>
            <a
              v-else
              class="text-decoration-underline"
              @click="
                $router.push({
                  name: 'JobAssemblingDetail',
                  params: { jobId: job.id, jobData: job },
                })
              "
            >
              {{ job.id_extern }}</a
            >
          </template>
          <template slot="button" slot-scope="{ job }">
            <button
              v-if="
                job.status == app.options.Job.STATUS.planned ||
                job.status == app.options.Job.STATUS.inprocess
              "
              type="button"
              :class="{
                'btn default-hover': true,
                'btn-primary': job.status == app.options.Job.STATUS.planned,
                'btn-next': job.status == app.options.Job.STATUS.inprocess,
              }"
              @click="
                $router.push({
                  name: 'JobAssemblingDetail',
                  params: { jobId: job.id, jobData: job },
                })
              "
            >
              {{
                job.status == app.options.Job.STATUS.planned
                  ? __(`jobs.components.list.${job.typeName}.buttons.start`)
                  : __(`jobs.components.list.${job.typeName}.buttons.proceed`)
              }}
            </button>

            <button
              v-if="job.status == app.options.Job.STATUS.cancelled"
              class="btn btn-highlighted btn-icon-left"
              @click="
                $router.push({
                  name: 'JobAssemblingDetail',
                  params: { jobId: job.id, jobData: job },
                })
              "
            >
              <img :src="icon('warning-important.svg')" />
              <span>{{
                __("jobs.components.list.common.buttons.cancelled")
              }}</span>
            </button>
            <button
              v-else-if="job.status == app.options.Job.STATUS.unfinished"
              class="btn btn-highlighted btn-icon-left"
              @click="
                $router.push({
                  name: 'JobAssemblingDetail',
                  params: { jobId: job.id, jobData: job },
                })
              "
            >
              <img :src="icon('warning-important.svg')" />
              <span>{{
                __("jobs.components.list.common.buttons.unfinished")
              }}</span>
            </button>
            <button
              v-else-if="job.status == app.options.Job.STATUS.finished"
              class="btn btn-secondary btn-icon-left"
              @click="
                $router.push({
                  name: 'JobAssemblingDetail',
                  params: { jobId: job.id, jobData: job },
                })
              "
            >
              <img :src="icon('door.svg')" />
              <span>{{
                __("jobs.components.list.common.buttons.finished")
              }}</span>
            </button>
          </template>
        </job-list>

        <div
          class="job-list-container__loader"
          v-if="container.isLoading && !offline"
        >
          <spinner></spinner>
        </div>
      </div>
      <button
        :class="{
          'btn mt-mdsm rounded-circle btn-qr-icon btn-next': true,
        }"
        @click="scanCode"
      >
        <img :src="icon('qr-icon.svg')" />
      </button>
      <div v-if="scanedCode" class="qr-alerts">
        <span class="warning-arrow"></span>
        <div class="d-flex flex-column align-items-end">
          <div
            :class="{
              alert: true,
              'alert-warning': scanedCode,
              'alert-success': !scanedCode,
            }"
          >
            <span v-html="scanedCodeMessage"></span>
          </div>
        </div>
      </div>
    </template>
  </data-container>
</template>

<script>
import NeedsJobsLoading from "../mixins/NeedsJobsLoading";
import QrScannerWindow from "../windows/QrScanner";
import { mapState } from "vuex";

export default {
  mixins: [NeedsJobsLoading],
  props: {
    job: {
      type: Number | Object,
    },
  },
  data() {
    return {
      scanedCode: false,
      scanedCodeMessage: "QR Code nicht vorhanden",
    };
  },
  computed: {
    ...mapState(["offline"]),
    statusFilter() {
      const statusIds = this.app.options.Job.STATUS;

      return [
        [
          [statusIds.open, statusIds.inquired],
          this.__("jobs.components.controls.common.filter.open"),
        ],
        [
          statusIds.planned,
          this.__("jobs.components.controls.common.filter.planned"),
        ],
        [
          statusIds.unfinished,
          this.__("jobs.components.controls.common.filter.unfinished"),
        ],
        [
          statusIds.finished,
          this.__("jobs.components.controls.common.filter.finished"),
        ],
      ];
    },
  },
  methods: {
    async doJobScan(job_id, id = null) {
      let paramId = {};
      if (id) {
        paramId = { partID: id };
      }
      const reportRoute = {
        name: "JobParts",
        params: { jobId: job_id, loadJobFromApi: true },
        query: paramId,
      };

      this.app.isLoading = true;
      await this.jobDataLoading;
      this.app.isLoading = false;

      this.$router.push(reportRoute);
    },
    unsetJob() {
      if (this.job) {
        this.$refs.container.setFilterKey("id", undefined);
        this.$router.push({ name: "Dashboard" }).catch((err) => {});
      }
    },
    async doJobPart(id = null, partId = null) {
      const partRoute = {
        name: "JobPart",
        params: { jobId: id, partId: partId, loadJobFromApi: true },
      };
      this.$router.push(partRoute);
    },

    async scanCode($triggerEvent = null) {
      this.loadPart = true;
      this.scanedCode = false;
      this.scanedCodeMessage = "QR Code nicht vorhanden";

      setTimeout(() => {
        const input = document.getElementById("qrcode_inp");
        input.focus();
      }, 100);

      const result = await this.$windows.showWindow(
        QrScannerWindow,
        $triggerEvent ? $triggerEvent.target : null
      );
      if (result) {
        const code = await this.$store.dispatch("jobs/respondQrCodeRequests", {
          code: result.code,
        });
        if (code.data) {
          this.loadPart = false;
          this.scanedCode = false;
          if (code.data.status && code.data.status == 1) {
            if (code.data.myJob) {
              this.doJobPart(code.data.job_id, code.data.part_id);
            } else {
              this.scanedCode = true;
              const manager = code.data.jobs.manager.name;

              this.scanedCodeMessage =
                "Sie besitzen keine Zugriffsrechte auf dieses laufendes Projekt. Projekt <b>" +
                code.data.jobs.id_extern +
                "</b> wird durch <b>" +
                manager +
                "</b> verwaltet.";
            }
          } else {
            this.doJobScan(code.data.job_id, code.data.part_id);
          }
        } else {
          // location.reload();
          this.scanedCode = true;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.btn-qr-icon {
  width: 64px;
  height: 64px;
  display: block;
  padding: 12px;
  min-width: auto;
  position: fixed;
  right: 20px;
  bottom: 20px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.qr-alerts {
  position: fixed;
  bottom: 30px;
  right: 90px;
  .warning-arrow {
    width: 10px;
    height: 10px;
    background: #ff9956;
    position: absolute;
    top: 50%;
    right: -4px;
    z-index: -1;
    transform: translate(00%, -50%);
    clip-path: polygon(50% 0%, 100% 50%, 50% 100%);
  }
}
</style>